import { Plugin } from 'chart.js';

// Plugin custom (chart.js 4). NB: attualmente non collegato ad alcun grafico via [plugins].
export function makeDrawValuePlugin(options?: any): Plugin {

	let textAlign: CanvasTextAlign = 'center';
	let textBaseline: CanvasTextBaseline = 'bottom';
	let formatDataFun = (value): string => {
		return Number(value).toLocaleString('US');
	};
	if(options){
		if(options.textPosition){
			if(options.textPosition.align) textAlign = options.textPosition.align;
			if(options.textPosition.baseline) textBaseline = options.textPosition.baseline;
		}
		if(typeof(options.formatDataFun)) formatDataFun = options.formatDataFun;
	}

	return {
		id: 'drawValue',
		afterDatasetsDraw(chart): void{
			const ctx = chart.ctx;
			ctx.save();
			ctx.textAlign = textAlign;
			ctx.textBaseline = textBaseline;

			chart.data.datasets.forEach(function (dataset, i): void {
				const meta = chart.getDatasetMeta(i);
				ctx.fillStyle = String(dataset.borderColor);

				meta.data.forEach(function (bar: any, index): void {
					const data = dataset.data[index];
					if(Array.isArray(dataset.borderColor)){
						ctx.fillStyle = String(dataset.borderColor[index]);
					}
					let textData = String(data);
					if(formatDataFun) textData = formatDataFun(data);
					if(textData) ctx.fillText(textData, bar.x, bar.y);
				});
			});
			ctx.restore();
		}
	};
}
